/**
 * @module actions/orderPrice
 */
import axios from 'axios'
import {
  API_URL,
  SET_PRICECALC_PRICES
} from '../constants'

/**
 * @description Getting the price using the API
 * @return {Promise} Axios promise
 */
export function getPrices (orderID, addon, evaluation, afterevaluation, deviation, otherDamage, editing, useSelectedEvaluation, department, getOnly) {
  let url = API_URL + '/Orderprice/Get'
  deviation = (deviation === false) ? 0 : deviation
  if (useSelectedEvaluation === undefined || useSelectedEvaluation == null) {
    useSelectedEvaluation = false
  }
  if (getOnly === undefined || getOnly == null) {
    getOnly = false
  }
  let data = {
    OrderId: orderID,
    Addon: addon,
    Evaluation: evaluation,
    AfterEvaluation: afterevaluation,
    Deviation: deviation,
    OtherDamage: otherDamage,
    GetEditing: editing,
    UseSelectedEvaluation: useSelectedEvaluation,
    Department: department,
    GetOnly: getOnly

  }
  return dispatch => {
    return axios.post(url, data).then((res) => {
      dispatch({
        type: SET_PRICECALC_PRICES,
        price: res.data
      })
      return res
    })
  }
}

/**
 * @description Getting the updated price using the API
 * @return {Promise} Axios promise
 */
export function updatePrices (data) {
  let url = API_URL + '/Orderprice/Post'
  return dispatch => {
    return axios.post(url, data).then((res) => {
      dispatch({
        type: SET_PRICECALC_PRICES,
        price: res.data
      })
      return res
    })
  }
}

/**
 * @description Approve price changes using the API
 * @return {Promise} Axios promise
 */
export function approvePrices (token, name, comment) {
  let url = API_URL + '/Orderprice/CustomerApproval/Approve'
  let data = {
    ApprovalToken: token,
    Name: name,
    Comment: comment
  }
  return dispatch => {
    return axios.post(url, data).then((res) => {
      return res
    })
  }
}

/**
 * @description Approve price changes using the API
 * @return {Promise} Axios promise
 */
export function rejectPrices (token, name, comment) {
  let url = API_URL + '/Orderprice/CustomerApproval/Reject'
  let data = {
    ApprovalToken: token,
    Name: name,
    Comment: comment
  }
  return dispatch => {
    return axios.post(url, data).then((res) => {
      return res
    })
  }
}

/**
 * @description Getting price for approval by token
 * @return {Promise} Axios promise
 */
export function getPricesForApproval (token) {
  let url = API_URL + '/Orderprice/CustomerApproval/Get/' + token
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Approve price changes using the API
 * @return {Promise} Axios promise
 */
export function getPricesForShopApproval (orderId, type, department) {
  let url = API_URL + '/OrderPrice/ShopApproval/Get'
  let data = {
    OrderId: orderId,
    Type: type,
    Department: department
  }
  return dispatch => {
    return axios.post(url, data).then((res) => {
      return res
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/orderPrice.js